export const LinkData = [
  {
    id: 1,
    title: "Home",
    url: "/",
  },
  {
    id: 2,
    title: "Our courses",
    url: "/courses",
  },
  {
    id: 3,
    title: "About",
    url: "/about",
  },
  {
    id: 4,
    title: "Our app",
    url: "/our-app",
  },
  {
    id: 5,
    title: "Contact us",
    url: "/contact",
  },
  {
    id: 6,
    title: "Gallery",
    url: "/gallery",
  },
  {
    id: 7,
    title: "News & Updates",
    url: "/news",
  },
]
export const courses = [
  {
    id: 1,
    cover: "../images/cpa.png",
    previewUrl: "https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/previewFiles%2Fvideo%2Fmp4%2F1688113915775000COMPANY%20LAW%20REVIEW.mp4?alt=media&token=ac3fe78e-5bbe-4319-9265-9ecfe7f3def2",
    title: "Certified Public Accountant",
    units: ["Foundation", "Intermediate", "Advanced"],
    description: "A Certified Public Accountant (CPA) is an experienced financial professional responsible for analyzing financial reports, conducting audits, forecasting revenue, managing accounts, and ensuring compliance with accounting standards."
  },
  {
    id: 2,
    cover: "../images/atd.png",
    previewUrl: "https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/previewFiles%2Fvideo%2Fmp4%2F1686402641288000ECONOMICS%20APP%20INTRO.mp4?alt=media&token=c0dacccd-85f0-4b9e-a115-2b4f4a731ad8",
    title: "Accounting Technician Diploma",
    units: ["Level 1", "Level II", "Level III"],
    description: "The Accounting Technicians Diploma qualification equips candidates with skills and competencies to work as middle level accountants providing technical support in accounting, auditing and taxation in both the public and private sectors."
  },
  {
    id: 3,
    cover: "../images/CIFA.png",
    previewUrl: "https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/previewFiles%2Fvideo%2Fmp4%2F1686401733746000Q.A%20INTRO%20MAIN.mp4?alt=media&token=5e921bb8-bdc1-4aeb-ad50-ac3dc5608bee",
    title: "Certified Investment and Financial Analysts",
    units: ["Foundation", "Intermediate", "Advanced"],
    description: "Certified Investment and Financial Analysts course is aimed at persons who wish to qualify and work or practice as investment, securities and financial analysts, portfolio managers, investment bankers, fund managers, consultants on national and global financial markets and related areas."
  },
  {
    id: 4,
    cover: "../images/CS.jpg",
    previewUrl: "https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/previewFiles%2Fvideo%2Fmp4%2F1687636955983000SM%20PREVIEW.mp4?alt=media&token=17c4d3ba-a277-4241-99fd-311a237e1c34",
    title: "Certified Secretaries",
    units: ["Foundation", "Intermediate", "Advanced"],
    description: " Certified Secretaies equips candidates for analyzing financial reports, conducting audits, forecasting revenue, managing accounts, and ensuring compliance with accounting standards."
  },
]

export const galleryImages = [
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery1.jpg?alt=media&token=fb36bc2b-ff44-4829-9811-a1bf8fb0c94e',
    title: 'Graduation Ceremony',
    description: 'A joyful graduation ceremony held at Pacesetters Institute.'
  },
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery10.jpg?alt=media&token=6fa14e7d-feae-445b-ac73-d7107b44c4ce',
    title: 'Classroom Session',
    description: 'Interactive session with students and faculty.'
  },
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery4.jpg?alt=media&token=ff4d09f9-38a0-4f9b-b2e5-ba2b193d9061',
    title: 'Sports Day',
    description: 'Annual AGM at Pacesetters'
  },
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery2.jpg?alt=media&token=f1c33a85-d7ab-4a77-8c76-2f2dee081935',
    title: 'Library',
    description: "Joyful photo session in annual AGM"
  },
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery3.jpg?alt=media&token=daca2a87-6133-4be0-9646-b762f136cf36',
    title: 'Science Lab',
    description: 'Community outreach programs at Pacesetters Institute.'
  },
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery5.jpg?alt=media&token=1fa09426-e06b-4e1b-9639-5d83856d222d',
    title: 'Community Outreach',
    description: 'Interactive session with students and faculty.'
  },
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery6.jpg?alt=media&token=79752311-2886-40ea-9f53-a2e5825cdbde',
    title: 'Community Outreach',
    description: 'Participants in community outreach programs at Pacesetters Institute.'
  },

  {
    url: 'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery7.jpg?alt=media&token=fce2ecb8-a530-452f-83d5-a275b2daef25',
    title: 'Community Outreach',
    description: 'Speech session AGM'
  },
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery8.jpg?alt=media&token=3afc8af5-0667-414d-8ef7-624567a87d4f',
    title: 'Community Outreach',
    description: 'Speech session AGM'
  },
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery9.jpg?alt=media&token=79d3f761-3da4-4c3e-a65c-5ae24296da52',
    title: 'Community Outreach',
    description: 'Photo session during the AGM'
  },
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery17.jpg?alt=media&token=15f4c544-e784-4f6a-b6f2-d378381d4698',
    title: 'Community Outreach',
    description: 'Pace setter mobile app launch .'
  },
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery16.jpg?alt=media&token=82b697f1-cc4d-4e93-8c1c-9ecfcc0f16d6',

    title: 'Community Outreach',
    description: 'Pace setter mobile app launch .'
  },
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery15.jpg?alt=media&token=2a563c8f-587c-4199-81e5-05dad5f11b4f',

    title: 'Community Outreach',
    description: 'Pace setter mobile app launch .'
  },
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery13.jpg?alt=media&token=ae8fd269-1247-41b7-85cb-30dba0d87e86',

    title: 'Community Outreach',
    description: 'Pace setter mobile app launch .'
  },
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery12.jpg?alt=media&token=230a9d9e-7011-4b72-8e41-4cdc78e38af4',
    title: 'Community Outreach',
    description: 'Pace setter mobile app launch .'
  },
];

export const newsArticles = [
  {
    id: 1,
    title: 'Pacesetters Institute Celebrates 25th Anniversary',
    description: 'Pacesetters Institute is proud to announce the celebration of its 25th anniversary. For over two decades, the institution has provided top-tier education and skills development to countless professionals across the globe. This milestone signifies...',
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery3.jpg?alt=media&token=daca2a87-6133-4be0-9646-b762f136cf36',
    date: 'October 5, 2024',
  },
  {
    id: 2,
    title: 'New Courses Launched for 2024',
    description: 'Pacesetters Institute has just introduced a range of new courses designed to help professionals upskill and stay relevant in the evolving job market. These courses include topics in AI, data science, leadership, and much more...',
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery6.jpg?alt=media&token=79752311-2886-40ea-9f53-a2e5825cdbde',
    date: 'October 3, 2024',
  },
  {
    id: 3,
    title: 'Graduation Ceremony 2024: A Day to Remember',
    description: 'The 2024 graduation ceremony was a grand event held at the Pacesetters Institute campus. Graduates from various fields celebrated their achievements, while keynote speakers shared insights on the importance of lifelong learning...',
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery9.jpg?alt=media&token=79d3f761-3da4-4c3e-a65c-5ae24296da52',
    date: 'September 30, 2024',
  },
];

export const successStories = [
  {
    id: 1,
    userImage: 'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery4.jpg?alt=media&token=ff4d09f9-38a0-4f9b-b2e5-ba2b193d9061',
    date: 'October 1, 2024',
    title: 'Achieved Career Growth',
    description: 'This course helped me gain practical skills and I was promoted to a senior position in my company.',
  },
  {
    id: 2,
    userImage: 'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery7.jpg?alt=media&token=fce2ecb8-a530-452f-83d5-a275b2daef25',
    date: 'September 15, 2024',
    title: 'New Opportunities',
    description: 'After completing the program, I landed a new job in my dream industry!',
  },
  {
    id: 3,
    userImage: 'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery8.jpg?alt=media&token=3afc8af5-0667-414d-8ef7-624567a87d4f',
    date: 'August 25, 2024',
    title: 'Increased Confidence',
    description: 'The training improved my confidence, and I now handle tasks more efficiently in my role.',
  },
  // Add more stories here
];

